import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import '../style/AboutContent.scss';

const AboutContent = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const textabout =
    "We transform ideas into powerful digital experiences. From custom web development to strategic marketing and multimedia content, we are your ultimate partner in growth.";

  const text = "Code • Design • Strategy • Content • ";
  const characters = text.split("");
  const degreeStep = 360 / characters.length;

  return (
    <section className="aboutSection">

      {/* Circular Seal — home page only */}
      {isHomePage && (
        <div className="sealContainer">
          <div className="innerLogo">
            <img
              src="/logo/logo evas.png"
              alt="Logo"
              width={80}
              height={80}
            />
          </div>

          <div className="textRing">
            {characters.map((char, i) => (
              <span
                key={i}
                style={{ transform: `rotate(${i * degreeStep}deg)` }}
              >
                {char}
              </span>
            ))}
          </div>
        </div>
      )}

      {/* Decorative Stars */}
      <div className="starContainer">
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
          className="star1"
        >
          <img src="/Icons/star-2.png" alt="" width={220} height={220} />
        </motion.div>

        <motion.div
          animate={{ rotate: -360 }}
          transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
          className="star2"
        >
          <img src="/Icons/star-2.png" alt="" width={40} height={40} />
        </motion.div>
      </div>

      <div className="container-about-title">
        <h3 className="about-title">
          {textabout.split(" ").map((word, i) => {
            const cleanWord = word.replace(/[.,]/g, '');

            return (
              <span key={i} className="wordWrapper">
                {cleanWord === "digital" ||
                cleanWord === "marketing" ||
                cleanWord === "growth" ? (
                  <span className="highlight">{word}</span>
                ) : (
                  word
                )}
                &nbsp;
              </span>
            );
          })}
        </h3>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="btnWrapper"
        >
          <Link to="/AboutUs" className="moreBtn">
            <span className="btnText">About More</span>

            <span className="iconBox">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
              >
                <path d="M7 17L17 7M17 7H7M17 7V17" />
              </svg>
            </span>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutContent;